export const addNote = (note) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const authorId = getState().firebase.auth.uid;

        firestore.collection('notes').add({
            ...note,
            authorFirstName: profile.firstName,
            authorLastName: profile.lastName,
            authorId: authorId
        }).then(() => {
            dispatch({type: 'ADD_NOTE',
                  note: note
                  }) 
        }).catch((err) => {
            dispatch({
                type: 'ADD_NOTE_ERROR', 
                err: err
            })
        })        
    };
}

export const removeNote = (id) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const firestore = getFirestore();

        firestore.collection('notes').doc(id).delete().then(() => {
            dispatch({type: 'REMOVE_NOTE',
                      id: id
                  }) 
        }).catch((err) => {
            dispatch({
                type: 'REMOVE_NOTE_ERROR', 
                err: err
            })
        })        
    };
}

export const editNote = (id, updates) => {
    return (dispatch, getState, {getFirebase, getFirestore}) => {
        const firestore = getFirestore();

        firestore.collection('notes').doc(id).update(updates).then(() => {
            dispatch({type: 'EDIT_NOTE',
                      id: id,
                      updates: updates
                  }) 
        }).catch((err) => {
            dispatch({
                type: 'EDIT_NOTE_ERROR', 
                err: err
            })
        })        
    };
}